module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_6.aaa7b01a.png";